import { render, staticRenderFns } from "./PgAgent.vue?vue&type=template&id=424e2421&scoped=true"
import script from "./PgAgent.vue?vue&type=script&lang=js"
export * from "./PgAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e2421",
  null
  
)

export default component.exports